import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion-9';
import { FormError } from '@tanium/react-form-context';
import { InfoTooltip } from '@tanium/react-info-tooltip';
import { Stack, StackChild } from '@tanium/react-stack';
import { css } from '@tanium/style-system';
import { FormInlineErrors } from './FormInlineErrors';
import { Label, SpanLabel } from './Label';
import { RequiredStar } from './RequiredStar';
import { DescriptionText } from './themeDefinitions';

export interface Props {
  children: React.ReactNode;
  description?: React.ReactNode;
  errors?: FormError[];
  label: React.ReactNode;
  required?: boolean;
  labelId?: string;
  helpText?: React.ReactNode;
}

const Wrapper = styled(Box)(
  css({
    mb: 3,
    ':last-child': {
      mb: 0,
    },
  }),
);

const FormRowInner = ({
  label,
  labelId,
  required,
  description,
  helpText,
  errors,
  children,
}: Props) => (
  <Wrapper>
    <Box mb={1}>
      <Stack itemSpacing={1}>
        {labelId ? <Label htmlFor={labelId}>{label}</Label> : <SpanLabel>{label}</SpanLabel>}
        {required && <RequiredStar />}
        {helpText && (
          <StackChild alignSelf="center">
            <InfoTooltip content={helpText} />
          </StackChild>
        )}
      </Stack>
    </Box>
    <Box>{children}</Box>
    {description && (
      <Box mt={1} fontSize={12} color={DescriptionText}>
        {description}
      </Box>
    )}
    {errors && errors.length > 0 && (
      <Box mt={1}>
        <FormInlineErrors errors={errors} />
      </Box>
    )}
  </Wrapper>
);

export const FormRow = React.memo(FormRowInner);
